import React from 'react';
import Chip from '@mui/material/Chip';
import Avatar from '@mui/material/Avatar';
import CheckIcon from '@mui/icons-material/Check'
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error'
import PropTypes from 'prop-types';
import {css} from '@emotion/react';
import {useTheme} from '@mui/material';

const getColors = (theme, variant) => {
	switch (variant) {
		case 'error':
			return {
				icon: '#fee0b8',
				iconBg: theme.palette.error.dark,
				textBg: theme.palette.error.main,
				text: theme.palette.getContrastText(theme.palette.error.main),
			};
		case 'warn':
			return {
				icon: '#f3f6c8',
				iconBg: '#ffc82b',
				textBg: '#fede32',
				text: theme.palette.getContrastText('#fede32'),
			};
		default:
		case 'ok':
			return {
				icon: theme.palette.secondary.light,
				iconBg: theme.palette.secondary.dark,
				textBg: theme.palette.secondary.main,
				text: theme.palette.getContrastText(theme.palette.secondary.main),
			};
	}
};


export const MessageChip = (props) => {
	const {label, variant = 'ok', onClick} = props;
	const theme = useTheme()
	const colors = getColors(theme, variant);
	const cssChip = css`
		margin: ${theme.spacing(1)};
		background: ${colors.textBg};
		color: ${colors.text};

		&:hover {
			background: ${colors.iconBg};
		}
	`
	const cssAvatar = css`
		width: 31px;
		height: 31px;
		margin: 0;
		color: ${colors.icon};
		background: ${colors.iconBg};
	`

	let IconComponent;
	switch (variant) {
		case 'error':
			IconComponent = ErrorIcon;
			break;
		case 'warn':
			IconComponent = WarningIcon;
			break;
		case 'ok':
			IconComponent = CheckIcon;
			break;
	}
	return (
		<Chip
			icon={<Avatar css={cssAvatar}><IconComponent fontSize={'small'}/></Avatar>}
			label={label}
			css={cssChip}
			onClick={onClick}
		/>
	);
};

MessageChip.propTypes = {
	variant: PropTypes.oneOf(['error', 'warn', 'ok']),
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	onClick: PropTypes.func,
};